<template>
  <div>
    <div class="login-header">
    </div>
    <div class="paper form login-card">
      <div>
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="87" height="54" viewBox="247 0 87 54"><image width="87" height="54" xlink:href="data:image/png;base64,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" data-name="black-icon" transform="translate(247)"/></svg>
      </div>
      <h3 v-html="view.translations.welcome_back_builder"/>
      <h5>{{ view.translations.enter_user_pass }}</h5>
      <h5 v-if="parseInt(windowWidth) < 740" class="ba-alert">{{ view.translations.builderall_not_working_in_mobile }}</h5>
      <form
        method="post"
        id="formLogin"
        ref="formLogin"
        :action="formLoginAction"
        @submit="loginSubmit"
      >
        <input
          type="hidden"
          name="login_type"
          id="login_type"
          :value="input_login_type"
        >
        <!-- v-model="input_login_type" -->
        <input
          type="hidden"
          name="token"
          id="token"
          :value="input_token"
        >
        <!-- v-model="input_token" -->
        <div :class="['text-left', input_email == '' ? '' : ($v.input_email.$invalid ? 'has-error' : 'has-success') ]" style="margin-top: 2rem">
          <label for="email" class="form-label">
            {{view.translations.email}} *
          </label>
          <input
            type="email"
            name="email"
            class="email"
            id="email"
            :placeholder="view.translations.email"
            required
            v-model="input_email"
            @change="onChange('input_email_v', input_email)"
            style="height: 4.5rem !important"
          >
        </div>
        <div :class="['text-left',  input_password == '' ? '' : ($v.input_password.$invalid ? 'has-error' : 'has-success') ]">
          <label for="senha" class="form-label" id="labelSenha">
            {{labelSenha}} *
          </label>
          <input
            type="password"
            name="senha"
            class="senha"
            id="senha"
            :placeholder="labelSenha"
            required
            v-model="input_password"
            @change="onChange('input_password_v', input_password)"
            style="height: 4.5rem !important"
          >
        </div>
        <div class="text-right va-forgot-password">
          <div class="checkbox">
            <input
              type="checkbox"
              name="virtual_assistant"
              id="virtual_assistant"
              v-show="false"
              v-model="checkbox_va"
              :value="checkbox_va ? 1 : 0"
            >
            <label for="virtual_assistant">{{view.translations.label_are_you_virtual_assistant}}</label>
          </div>
          <div class="separator"></div>
          <div class="forgot-password">
            <a
              class=""
              :href="view.routes['forgot-password']"
            >
              {{ view.translations.forgot_password }}
            </a>
          </div>
        </div>
        <div>
          <button
            id="submit-btn"
            name="submit_btn"
            class="btn-success display-block"
            :disabled="$v.input_email.$invalid || $v.input_password.$invalid"
          >
            {{view.translations.button_login}}
          </button>
        </div>
        <div class="separator">
          <hr/><span>
              {{ view.translations.or_login_with }}
          </span><hr/>
        </div>
      </form>
      <div id="g_id_onload"
           :data-client_id="view.constList.google_client_id"
           data-context="signin"
           data-ux_mode="popup"
           data-callback="callback"
           data-auto_prompt="false"
           style="display: none!important;">
      </div>
      <div class="social-buttons">
        <div class="g_id_signin"
             data-type="standard"
             data-shape="rectangular"
             data-theme="outline"
             data-text="signin"
             data-size="large"
             data-logo_alignment="left"
             :data-width="parseInt(windowWidth) > 500 ? currentWidth : 'auto'">
        </div>
      </div>
      <div class="login-footer">
        <div  class="dont-have-account">
          {{view.translations.label_dont_have_an_v5}}
          <a
            class=""
            :href="custom_register_route"
          >
            {{view.translations.label_account_v5}}
          </a>
        </div>
        <div class="all-rights-reserved" >
          {{view.translations.label_all_rights_reserved_v5}}
          <b>
            {{view.translations.label_ebusiness4us_v5}}
          </b>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SpringSpinner } from 'epic-spinners'
const { required, email } = require('vuelidate/lib/validators')
export default {
  name: 'lv5-form',
  props: ['view'],
  components: {
    'spring-spinner': SpringSpinner
  },
  validations: {
    input_email: {
      required,
      email
    },
    input_email_v: {
      required,
      email
    },
    input_password: {
      required
    },
    input_password_v: {
      required
    }
  },
  data: function(){
    return {
      loadingFacebookApi: false,
      disableFacebookBtn: true,

      office_btn: '',

      input_login_type: '',
      input_token: '',
      input_email: '',
      input_email_v: '',
      input_password: '',
      input_password_v: '',
      checkbox_va: false,

      custom_register_route: "",

      google_btn_w: 0,
      windowWidth: window.innerWidth,
      currentWidth: 400
    }
  },
  methods: {
    beforeDestroy() {
      window.removeEventListener('resize', this.onResize);
    },
    onResize() {
      this.windowWidth = window.innerWidth
    },
    fbAsyncInit(){
      let vm = this
      FB.init({
        appId: vm.view.constList.facebook_app_id,
        cookie: true, // enable cookies to allow the server to access
        // the session
        xfbml: true, // parse social plugins on this page
        version: 'v3.2', // The Graph API version to use for the call
        oauth: true,
        status: true,
      });
    },
    showAlert(){
      this.$toast.error(this.view.translations.unavailable_service_enter_email_password);
    },
    alertMsg(type, msg) {
      var html = '<div class="alert alert-'+type+' alert-fade">'+
        '<button type="button" class="close" data-dismiss="alert">&times;</button>'+
        msg+
        '</div>';
      $('#alert-msg').html(html);
      $('.alert-fade').removeClass("animated fadeOutUp");
      $('.alert-fade').addClass("animated fadeInDown");
      setTimeout(function(){
        $('.alert-fade').removeClass("animated fadeInDown");
        $('.alert-fade').addClass("animated fadeOutUp");
        setTimeout(function(){
          $('.alert-fade').addClass("hide");
        }, 500);
      }, 7000);
    },
    fb_login(){
      let vm = this;
      if(!this.disableFacebookBtn){
        FB.login(function(response) {
          if (response.status === 'connected') {

            console.log('Welcome!  Fetching your information.... ');

            let access_token = response.authResponse.accessToken; //get access token
            //user_id = response.authResponse.userID; //get FB UID

            //Set input token
            vm.input_token = access_token;

            //Set input tipo_login
            vm.input_login_type = vm.view.data.login_type.FACEBOOK;

            //Send form
            setTimeout(()=>{
              vm.$refs.formLogin.submit();
            }, 2000);

          } else {
            //user hit cancel button
            console.log('User cancelled login or did not fully authorize.');
          }
        }, {scope: 'public_profile,email'});
      }
    },
    loginSubmit() {
      this.$emit('login-submit');
    },
    removeParam(key, sourceURL) {
      let rtn = sourceURL.split("?")[0];
      let param = '';
      let params_arr = [];
      let queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";

      if (queryString !== "") {
        params_arr = queryString.split("&");
        for (var i = params_arr.length - 1; i >= 0; i -= 1) {
          param = params_arr[i].split("=")[0];
          if (param === key) {
            params_arr.splice(i, 1); // remove param
          }
        }
        rtn = rtn + "?" + params_arr.join("&");
      }
      return rtn;
    },
    toggleOfficeButton(){
      console.log('toggle')
      this.office_btn = this.office_btn === 'normal' ? 'business' : 'normal';

      if(this.office_btn == 'normal') {
        var alteredURL = this.removeParam('redir', window.location.href );
        window.history.pushState({ path: alteredURL }, '', alteredURL);
      }
      if(this.office_btn == 'business') {
        var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?app=ba5&redir=%2Fbr%2Foffice%2Ffranchise-system';
        window.history.pushState({ path: newurl }, '', newurl);
      }

      this.$emit('toggle-office-button')
    },
    onLoadFacebookApi() {
      let vm = this;
      vm.loadingFacebookApi = false;
      vm.disableFacebookBtn = false;
    },
    onReadyStateChangeFacebookApi(facebookEl) {
      if (facebookEl.readyState === 'complete') {
        this.onLoadFacebookApi();
      }
    },
    initFacebookApi(){
      let vm = this;
      this.loadingFacebookApi = true;

      let facebookEl = document.createElement('script');
      let lang = navigator.language || navigator.userLanguage;

      facebookEl.setAttribute("type", "text/javascript");
      facebookEl.setAttribute("async", "async");
      facebookEl.setAttribute("defer", "defer");
      lang = lang.replace('-','_');
      facebookEl.setAttribute('src', 'https://connect.facebook.net/'+lang+'/all.js');

      if (facebookEl.addEventListener) {
        facebookEl.addEventListener('load', function () {
          vm.onLoadFacebookApi();
        });
      } else { // fallback
        facebookEl.onreadystatechange = function () {
          vm.onReadyStateChangeFacebookApi(facebookEl);
        };
      }

      document.getElementById('fb-root').appendChild(facebookEl);
    },
    onChange(key, value) {
      this[key] = value;
      this.$v[key].$touch();
    },
    setAidHashToCreatePage(){
      this.custom_register_route = this.view.routes['dont-have-account'];
      let hash = location.hash;
      hash =  hash.substring(1);
      hash = hash.split('&');

      for(let i =0; i < hash.length; i++){
        if(hash[i].indexOf('aid') === 0){
          this.custom_register_route = this.view.routes['dont-have-account'] + '/#' + hash[i];
        }
      }
    },
  },
  created() {
    this.office_btn = this.view.data.redirDefined ? 'business' : 'normal'
    this.setAidHashToCreatePage();
  },
  mounted(){
    window.fbAsyncInit = this.fbAsyncInit;
    this.initFacebookApi();

    let vm = this;
    $(window).on('load', function(){
      setTimeout(() => {
        if(vm.view.data.back_toastr_message !== false){
          vm.$toast[vm.view.data.back_toastr_message_type](vm.view.data.back_toastr_message.replace(/(<([^>]+)>)/ig," "))
        }
      }, 800)
    })
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    })
  },
  computed: {
    labelSenha() {
      return this.checkbox_va ? this.view.translations.label_access_key : this.view.translations.Senha;
    },
    formLoginAction() {
      return this.checkbox_va ? this.view.routes['rota-office-login-va'] : '';
    },
  },
  watch: {
    '$v.$invalid': {
      handler: function(newVal, oldVal) {
        if( !newVal ) {
          this.$toast.clear();
        }
      },
      deep: true
    },
    '$v.input_email_v.required': {
      handler: function(newVal, oldVal) {
        if( !newVal ) {
          this.$toast.error( window.getInnerComponent(`${this.view.translations.email} ${this.view.translations.label_required_v5}`) );
        }
      },
      deep: true
    },
    '$v.input_email_v.email': {
      handler: function(newVal, oldVal) {
        if( !newVal ) {
          this.$toast.error( window.getInnerComponent(this.view.translations.label_invalid_email_v5) );
        }
      },
      deep: true
    },
    '$v.input_password_v.required': {
      handler: function(newVal, oldVal) {
        if( !newVal ) {
          this.$toast.error( window.getInnerComponent(`${this.labelSenha} ${this.view.translations.label_required_v5}`) );
        }
      },
      deep: true
    },
  }
}
</script>

<style lang="scss">
.login-new {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 10%;
}
.login-card {
  padding: 63px 10rem !important;
  max-width: 60rem !important;

  -webkit-box-shadow: 14px 10px 33px -1px rgba(0,0,0,0.51) !important;
  -moz-box-shadow: 14px 10px 33px -1px rgba(0,0,0,0.51) !important;
  box-shadow: 14px 10px 33px -1px rgba(0,0,0,0.51) !important;
  .dont-have-account {
    margin-top: 20px;
    color: #000000;
    a {
      font-size: 1.5rem;
      color: #2560DF;
    }
  }
  .all-rights-reserved {
    margin-top: 20px;
    color: #0000005e;
    b {
      color: #000000;
    }
  }
  h3 {
    text-align: center;
    color: #000000 !important;
  }
  h5 {
    margin-top: 1.3rem !important;
    color: #000000 !important;
    opacity: .5;
  }
  .ba-alert{
    color: red !important;
    opacity: 0.9 !important;
  }
  input {
    padding: 10px !important;
  }
  #submit-btn {
    background: RGBA(38, 97, 223, 1) !important;
    padding: .6em 2em !important;
  }
  .checkbox {
    label {
      color: #000000 !important;
      opacity: .5;
    }
  }
  .text-left {
    label {
      color: #000000ba !important;
    }
  }
  .forgot-password {
    a {
      color: #2560DF !important;
      font-weight: normal !important;
    }
  }
  .separator {
    hr {
      border-top: 1px solid #000000ba !important;
    }
    span {
      color: #0000005e;
      text-transform: capitalize !important;
    }
  }
}
.builderall-css .login-card .social-buttons .social-button-login .social-button-icon {
  font-size: 2.3rem !important;
}
.social-buttons {
  display: inline-flex;
  justify-content: center;
}
.social-button-text, .social-button-login {
  padding: 0 !important;
}
.social-button-login {
  width: 200px;
}
@media only screen and (max-width: 1400px) {
  .builderall-css .login-card .social-buttons .social-button-login {
    font-size: 1.4rem !important;
  }
  .social-button-login {
    width: 170px !important;
  }
}
@media only screen and (max-width: 1010px) {
  .social-button-login {
    width: 400px !important;
  }
}
@media only screen and (max-width: 901px) {
  .builderall-css .login-card .social-buttons .social-button-login {
    font-size: 1.2rem !important;
  }
  .social-button-login {
    width: 300px !important;
  }
}
@media only screen and (max-width: 740px) {
  .builderall-css .login-card {
    padding: 4.5rem !important;
    width: 90vw;
  }
  .login-new{
    left: 50%;
    right: auto;
    transform: translate(-50%, -50%);
  }
}
@media only screen and (max-width: 715px) {
  .builderall-css .login-card .social-buttons .social-button-login {
    font-size: 1.2rem !important;
  }
  .social-button-login {
    width: 200px !important;
  }
}
@media only screen and (max-width: 500) {
  .social-button-login {
    width: 100px !important;
  }
}
.btn-success:hover {
  box-shadow: 0 0.48rem 1.52rem -0.32rem #2560DF !important;
}
</style>



// WEBPACK FOOTER //
// resources/office/js/components/login-v5/forms/login_new.vue